<template>
  <div class="pricebar">
    <nuxt-link to="/" class="logo"> Pedalsure. </nuxt-link>

    <Price />
  </div>
</template>

<script>
import Price from './Price'
export default {
  name: 'PriceBar',
  components: { Price },
}
</script>

<style lang="scss" scoped>
.logo {
  font-size: 25px;
  font-weight: 500;
  color: black;
  @include tablet {
    font-size: 30px;
  }
}
.pricebar {
  display: flex;
  align-items: center;
  border-bottom: 1px solid $ps-primary;
  padding: 15px;
  justify-content: space-between;
  @include tablet {
    padding: 15px 20%;
  }
}
</style>
